import { Flex, Button, Typography, Row, Col, Select, Image, Spin } from 'antd'
import { useContext, useEffect } from 'react'

//import { CheckpointTypes } from '../../types'
import Constant from '../../controller/Constant'
import useImg2Img from '../../hooks/useImg2Img'
import { AppContext } from '../../hooks/AppContext'
import UploadOneImage from './components/UploadOneImage'
import { LoadingOutlined } from '@ant-design/icons'
import useRenderHistory from '../../hooks/useRenderHistory'

const GenerateImgFromImgScreen = () => {
  const { setMenuSelected } = useContext(AppContext)
  const {getRenderProcessing} = useRenderHistory()

  const {
    mediaProcessingJobID,
    getMediasProcessing,
    isStopLoop,
    isDisable,
    //checkIsDisabled,
    //checkPointSelected,
    //handleSelectCheckpoint,
    //checkPoints,
    //getNewCheckpoint,
    renderStatus,
    handleGenerateImg,
    handleDownloadImg,
    generatedImages,
    imageFile,
    setImageFile,
    imageBase64,
    setImageBase64,
    faceImageFile,
    setFaceImageFile,
    faceImageBase64,
    setFaceImageBase64
  } = useImg2Img()

  useEffect(() => {
    setMenuSelected(Constant.keyScreen.img2img)
    //getNewCheckpoint()
  }, [])

  useEffect(() => {
    if (mediaProcessingJobID) {
      const timerId = setInterval(() => { 
        getMediasProcessing()
      }, 5000)

      if (isStopLoop) {
        clearInterval(timerId)
      }

      return () => {
        clearInterval(timerId)
      }
    }
  }, [mediaProcessingJobID, isStopLoop])
  
  useEffect(() => {
    const timerId = setInterval(() => {
      getRenderProcessing()
    }, 5000)

    return () => {
      clearInterval(timerId)
    }
  }, [])

  return (
    <>
      <h1 className='title'>画像生成</h1>
      <Flex vertical justify='center' align='center'>
        <Flex vertical justify='center' align='center' className='pt-10'>
          <Flex gap="middle">
            <Flex justify='center' vertical>
              <span className='text-[#6B7280]'>Background image</span>
              <UploadOneImage
                imageFile={imageFile}
                setImageFile={setImageFile}
                imageBase64={imageBase64}
                setImageBase64={setImageBase64}
                isDisabled={isDisable}
              />
            </Flex>
            <Flex justify='center' vertical>
              <span className='text-[#6B7280]'>Face image</span>
              <UploadOneImage
                imageFile={faceImageFile}
                setImageFile={setFaceImageFile}
                imageBase64={faceImageBase64}
                setImageBase64={setFaceImageBase64}
                isDisabled={isDisable}
              />
            </Flex>
          </Flex>
          {/*<Col className='mt-5 ml-4'>
            <Row className='items-center mb-[10px] justify-between'>
              <Typography>モデル</Typography>
              <Select
                className='min-w-[250px] ml-5 h-9'
                disabled={checkIsDisabled()}
                value={checkPointSelected?.name}
                onChange={handleSelectCheckpoint}
              >
                {checkPoints?.map((item: CheckpointTypes) => (
                  <Select.Option key={item?.id} value={item.name} new_checkpoint={item.new_checkpoint}>
                    <p>{item?.name}</p>
                  </Select.Option>
                ))}
              </Select>
            </Row>
          </Col>*/}
          <Button
            className='font-bold w-[105px] mt-[20px] mb-[30px]'
            onClick={handleGenerateImg}
            type='primary'
            disabled={isDisable}
          >
            生成する
          </Button>
          <Flex vertical className=' mb-[80px] mt-[30px] w-full'>
            {(isDisable || (!!renderStatus)) && (
              <>
                <Typography.Text className='font-bold mb-4'>生成画像</Typography.Text>
              </>
            )}
            {(isDisable || (renderStatus == Constant.processing.PROCESSING)) && (
              <Flex justify='center'>
                <Spin spinning={true} indicator={<LoadingOutlined className='text-[14px]' />}>
                  <div className='h-[135px] bg-gray-500 aspect-[3/4]' />
                </Spin>
              </Flex>
            )}
            {[Constant.processing.PROCESSING, Constant.processing.SUCCESS, Constant.processing.FAIL].includes(
              renderStatus
            ) && (
              <>
                {renderStatus == Constant.processing.SUCCESS && (
                  <Flex justify='center' align='center'>
                    {generatedImages?.map((item) => {
                      return (
                        <Flex key={item?.id} vertical className='mt-[15px] mb-5 mr-4 ml-4'>
                          <Image
                            className='flex justify-center items-center object-cover'
                            src={item?.url}
                            height={340}
                          />
                          <Button
                            onClick={() => handleDownloadImg(item?.url)}
                            className='font-bold w-[130px] bg-[#03B048] hover:bg-[#03B048] text-white mt-5 self-center'
                          >
                            ダウンロード
                          </Button>
                        </Flex>
                      )
                    })}
                  </Flex>
                )}
                {renderStatus == Constant.processing.FAIL && (
                  <Flex vertical justify='center' align='center'>
                    <img
                      className='flex justify-center items-center mt-[15px] mb-5'
                      src={require('../../assets/render-fail.png')}
                      width={60}
                      height={60}
                    />
                    <Typography.Text className='text-red-600'>
                      画像の生成が失敗しました。再度生成してください。
                    </Typography.Text>
                  </Flex>
                )}
                <Typography.Text className='w-6'></Typography.Text>
              </>
            )}
          </Flex>
        </Flex>
      </Flex>
    </>
  )
}

export default GenerateImgFromImgScreen
